<template>		
	<div class="auth-form">
		<div class="text-center logo"><img :src="stylePathToLogo || '/static/img/logo/logo.png'" /></div>

		<h4 class="text-center">{{ formData && formData.title ? formData.title : 'register/title' | ftc }}</h4>

		<template v-if="errorWithLogout">
			<div class="text-center alert alert-danger" style="margin: 30px 0">
				<p style="margin: 0; padding: 10px;" v-withSafeTags="errorWithLogout"></p>
			</div>
			<button type="button" class="btn btn-submit btn-primary btn-block" @click.prevent="logOut">{{ 'login/logout' | ftc }}</button>
		</template>

		<template v-if="!errorWithLogout">

			<div v-if="form_ErrorMessage">
				<div class="alert alert-danger w5-error-block"
					role="alert"
					style="padding: 10px; margin: 20px 0 20px"
					v-withSafeTags="localeFtc(form_ErrorMessage)">
				</div>
	
				<button type="button" class="btn btn-submit btn-primary btn-block" @click.prevent="softReloadApp">{{ 'main/update' | ftc }}</button>
			</div>

			<form v-if="formData && !successMessage" class="w5-from" autocomplete="off">
				<fieldset :disabled="form_Loading">

					<div v-for="(row, index) in formData.fields" :key="index" class="w5-form-row">
						<template v-if="row && row.length">
							<template v-for="field in row">
								<Field v-if="['locale', 'code'].indexOf(field._field_name) < 0"
									:key="field._field_name"
									:ref="field._field_name"
									:isVisibleRow="field._visible"
									:Field="field"
									v-model="field.value"
									style="padding: 10px 0"
									@valueChanged="onFormFieldChanged(field, formData)"
									@blur="onFormBlur(field, formData)"
									@focus="onFormFocus(field, formData)"
									@enterKeyDown="onFormEnterKeyDown"
								/>
							</template>
						</template>
					</div>

					<div class="w5-field text-center" style="padding: 10px 0">
						<img v-if="form_Loading" src="/static/img/loading32.gif" />
						<button v-else
							class="btn btn-submit btn-primary btn-block"
							type="button"
							ref="button"
							@click="registration">{{ 'page/user_register' | ftc }}</button>
					</div>

				</fieldset>
			</form>
			<div v-else :style="form_ErrorMessage || successMessage ? 'height: 0' : 'height: 135px'"></div>

			<div v-if="successMessage" class="text-center alert alert-success" style="margin: 30px 0">
				<p style="margin: 0; padding: 10px;" v-withSafeTags="successMessage"></p>
			</div>

			<div v-if="formData && !form_Loading && !form_ErrorMessage" style="margin:10px 0">
				<template v-if="!successMessage">
					<span>{{ 'login/already_registered' | ftc }}</span>
					<router-link to="/login">{{ 'main/enter' | ftc }}</router-link>
				</template>
				<button v-else class="btn btn-submit btn-primary btn-block" type="button" @click="successToPanel" v-show="!form_Loading">{{ 'main/enter' | ftc }}</button>
			</div>

		</template>
	</div>		
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Field from '@/components/elements/formfield'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'registrationForm',

	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			// сообщение об успехе
			successMessage: '',
			// ошибка с разлогином
			errorWithLogout: '',
			// данные формы
			formData: null
		}
	},

	//=========================================================================
	// событие: компонент создан
	//=========================================================================
	created() {
		// если пользователь авторизован - редирект на главную страницу
		if (this.$store.state.is_auth)
		{
			// делаем редирект
			return this.$router.push('/')
		}

		// запросим форму
		this.formRequest()
	},

	//=========================================================================
	// функции компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// запрос данных формы
		//---------------------------------------------------------------------
		formRequest() {
			// запросим форму
			this.getFormFromCache('/user/register')
			.then(formData => {
				if (formData &&
					formData.title &&
					formData.fields &&
					formData._csrf &&
					formData.model)
				{
					const newData = this.parseFormData(formData, this.formData)
					if (newData) this.formData = newData
				}

				if (formData &&
					formData.status === 'error' &&
					formData.message &&
					formData.message.length)
				{
					this.form_ErrorMessage = this.localeFtc(formData.message)

					// если это Blacklisted
					if (String(formData.message).toLowerCase().indexOf('blacklisted') !== -1)
					{
						// сборс данных формы
						this.formData = null
					}
				}
			})
		},

		//---------------------------------------------------------------------
		// реакция на отрицательный результат запроса
		//---------------------------------------------------------------------
		failRequest(error) {
			this.form_ErrorMessage = false
			this.errorWithLogout = ''

			if (error && typeof error === 'object' &&
				error.data &&
				error.data.status === 'error' && error.data.content && error.data.title &&
				error.data.content === 'user/need_logout')
			{
				this.errorWithLogout = '<b>' + this.localeFtc(error.data.title) + '</b><br><br>' + this.localeFtc(error.data.content)
				return
			}

			let _msg = this.localeFtc('main/validation_error')
			let _isError = false

			if (error && typeof error === 'object' && error['email'])
			{
				_isError = true

				if (Array.isArray(error['email']) && error['email'].length) _msg = this.localeFtc(error['email'][0])
				else _msg = this.localeFtc(error['email'])

				const field = this.findFormField('email', this.formData['fields'])
				if (field) field['_errMsg'] = _msg
			}

			if (error && typeof error === 'object' && error['captcha'])
			{
				_isError = true

				if (Array.isArray(error['captcha']) && error['captcha'].length) _msg = this.localeFtc(error['captcha'][0])
				else _msg = this.localeFtc(error['email'])

				const field = this.findFormField('captcha', this.formData['fields'])
				if (field) field['_errMsg'] = _msg
			}

			// если это не ошибка по полю
			if (!_isError)
			{
				// общая ошибка
				this.form_ErrorMessage = _msg
			}

			// в любом случае запросим форму - так как может появиться поле "капча"
			this.formRequest()
		},

		//---------------------------------------------------------------------
		// запрос на регистрацию
		//---------------------------------------------------------------------
		registration() {
			// проверка загрузки
			if (this.form_Loading) return

			// проверка формы
			if (!this.formData || !this.formData['fields']) return

			// обнуляем ошибку и сообщение
			this.form_ErrorMessage = false
			this.successMessage = ''

			// бежим по всем полям и собираем данные
			const _data = this.collectFormData(this.formData['fields'], this.localFormValidation)
			// если данные по каким либо причинам собрать не удалось
			if (_data === false) return

			// готовим объект запроса и url запроса
			_data['locale'] = this.$store.state.lang

			// запрос на регистрацию
			const _url = '/user/register'
			this.forms_GetThenPost(_url, _data,
				// успех
				() => {
					// покажем сообщени
					this.successMessage = this.localeFtc('register/success<br><br> register/email_sent')
				},
				// неудача
				(error) => {
					// если это 403 Blacklisted
					if (error && error.status === 403 && error.data && error.data.content === 'Blacklisted')
					{
						// ставим текст сообщения
						this.form_ErrorMessage = this.localeFtc('login/blacklisted')
						// обнуляем форму
						this.formData = null
					}
					// иная ошибка
					else this.failRequest(error)
				}
			)
		},

		//---------------------------------------------------------------------
		// кликнули после успешной регистрации - переводим в панель,
		// пользователь уже залогинен
		//---------------------------------------------------------------------
		successToPanel() {
			// "тяжелый" переход - c загрузкой всего приложения
			// иначе в FF начинает все время спрашивать "сохранить пароль?"
			window.location.href = '/'
			window.location.reload(true)
		},

		//---------------------------------------------------------------------
		// процедура выхода
		//---------------------------------------------------------------------
		logOut() {
			// запрос на выход из системы
			this.forms_GetThenPost('/logout', false,
				// успех
				() => {
					this.$store.commit('dropAuth')
					this.$router.push('/login')
				},
				// провал
				() => {
					this.$router.push('/')
				}
			)
		}

		//---------------------------------------------------------------------
	},

	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// Registration.vue?2ed2c3ba